import { render, staticRenderFns } from "./ReturnItemModel.vue?vue&type=template&id=77bda7ec&scoped=true&"
import script from "./ReturnItemModel.vue?vue&type=script&lang=js&"
export * from "./ReturnItemModel.vue?vue&type=script&lang=js&"
import style0 from "./ReturnItemModel.vue?vue&type=style&index=0&id=77bda7ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bda7ec",
  null
  
)

export default component.exports